import React, { Component } from 'react';

// Components
import NfTableHeader from './NfTableHeader';
import NfTableBody from './NfTableBody';
import Pagination from '../../../../../../components/Pagination';

// CSS
import './styles.css';

export default class NfTable extends Component {
  constructor() {
    super();
    this.state = {
      headers: [
        { title: 'NF', alignment: 'left', highlighted: false },
        { title: 'Destinatário', alignment: 'left', highlighted: false },
        { title: 'Cidade / UF', alignment: 'center', highlighted: false },
        { title: 'Embalagem', alignment: 'center', highlighted: false },
        { title: 'Volumes (un)', alignment: 'right', highlighted: false },
        { title: 'Peso (kg)', alignment: 'right', highlighted: false },
        { title: 'Valor (R$)', alignment: 'right', highlighted: false },
        {
          title: 'Data de Solicitação',
          alignment: 'right',
          highlighted: false,
        },
      ],
      paginationOptions: [
        {
          value: 10,
          label: '10',
        },
        {
          value: 25,
          label: '25',
        },
        {
          value: 50,
          label: '50',
        },
        {
          value: 100,
          label: '100',
        },
      ],
      currentPage: 1,
      currentPageLimit: 10,
    };
  }

  _changePage = (newPage) => {
    this.props.onChangePage(newPage, this.state.currentPageLimit);

    this.setState({
      currentPage: newPage,
    });
  };

  _changePageLimit = (newPageLimit) => {
    this.props.onPageLimitChange(1, newPageLimit);

    this.setState({
      currentPage: 1,
      currentPageLimit: newPageLimit,
    });
  };

  render() {
    const {
      data, selectNf, nfSelecteds, paginated, totalItems,
    } = this.props;
    return (
      <div className="NfTable">
        <table className="NfTable__table">
          <NfTableHeader headers={this.state.headers} />
          <NfTableBody
            data={data}
            headers={this.state.headers}
            selectNf={selectNf}
            nfSelecteds={nfSelecteds}
            getLabelById={this.props.getLabelById}
          />
          {paginated && (
            <tr>
              <td colSpan={9}>
                <Pagination
                  options={this.state.paginationOptions}
                  currentPage={this.state.currentPage}
                  pageLimit={this.state.currentPageLimit}
                  totalItems={totalItems}
                  onChangePage={this._changePage}
                  onPageLimitChange={this._changePageLimit}
                />
              </td>
            </tr>
          )}
        </table>
      </div>
    );
  }
}
